function HandleBundleProductCardClick( e )
{
    e.stopPropagation();
    e.preventDefault();
    var bundleProductCard   = e.currentTarget;
    var wrapper             = bundleProductCard.parentNode;

    var bundleProductCards = wrapper.querySelectorAll( ".product_box" );
    bundleProductCards.forEach( function( el )
    {
        el.classList.remove( "active" );
    } );

    bundleProductCard.classList.add( "active" );

    var bundleProductCardData = JSON.parse( bundleProductCard.querySelector( "[data-bundle-data]" ).innerHTML );

    var bundleProductCardProductID = bundleProductCard.getAttribute( "data-ss-product" );
    var bundleProductCardVariantID = bundleProductCard.getAttribute( "data-ss-variant" );

    HandleSubscriptionWidgets( bundleProductCardVariantID, bundleProductCardProductID, bundleProductCardData.sellingPlanID, wrapper );

    HandlePriceMessage( wrapper, bundleProductCardData );
}

function HandleSubscriptionWidgets( bundleProductCardVariantID, bundleProductCardProductID, sellingPlanID, bundleWrapper )
{
    var form                        = bundleWrapper.closest( "form[ action='" + window.Shopify.routes.root + "cart/add' ]" );
    var ssWidgets                   = form.querySelectorAll( ".hh-ss-wrapper" );
    var activeSSWidget              = form.querySelectorAll( ".hh-ss-wrapper:not(.hidden)" );
    var widget                      = form.querySelector( ".hh-ss-wrapper" );
    var currentSubscriptionOption   = "subscribe";

    activeSSWidget.forEach( function( ssWrapper )
    {
        var checkedInput                = ssWrapper.querySelector( "input.hh-subscription-option-input:checked" );
        currentSubscriptionOption       = checkedInput.value;
    } );

    ssWidgets.forEach( function( ssWrapper )
    {
        var variantID = ssWrapper.getAttribute( "data-ss-variant" );

        ssWrapper.classList.add( "hidden" );

        if( bundleProductCardVariantID == variantID )
        {
            ssWrapper.classList.remove( "hidden" );
            widget  = ssWrapper;
        }
    } );

    // Update the product form to reflect the correct variant and selling plan
    var productForm         = widget.closest( "form[ action='" + window.Shopify.routes.root + "cart/add' ]" );
    var variantInput        = productForm.querySelector( "[ name='id' ]" );
    var productInput        = productForm.querySelector( "[ name='product-id' ]" );
    var sellingPlanInput    = productForm.querySelector( "[ name='selling_plan' ]" );

    var widgetSubscriptionOptionInput   = widget.querySelector( ".hh-subscription-option-input[ value='"+ currentSubscriptionOption +"' ]" );
    var widgetSubscriptionOption        = widgetSubscriptionOptionInput.closest( ".hh-ss-option" );

    variantInput.setAttribute( "value", bundleProductCardVariantID );
    productInput.setAttribute( "value", bundleProductCardProductID );
    sellingPlanInput.setAttribute( "value", sellingPlanID  );

    widgetSubscriptionOption.querySelector( "label" ).click();
    HandleBundleCards( widget, widget.querySelector( "input.hh-subscription-option-input:checked" ) )
}

function HandlePriceMessage( wrapper, data, checkedInput )
{
    if( wrapper && data )
    {
        var form = wrapper.closest( "form" );
        var message = form.querySelector( ".hh-price-message-wrapper[data-price-message] span[data-price-message-text]" );
        if( !checkedInput )
        {
            var productID = data.productID;
            var isSubscription = form.querySelector( ".hh-ss-wrapper[data-ss-product='" + productID + "'] input.hh-subscription-option-input:checked" );
        }
        else
        {
            var isSubscription = checkedInput;
        }
        if( isSubscription.value == "subscribe" )
        {
            isSubscription = true;
            form.setAttribute( "data-purchase-type", "subscription");
        }
        else
        {
            isSubscription = false;
            form.setAttribute( "data-purchase-type", "one-off");
        }
        if( message )
        {
            if( data.compareAtPriceText.length > 0 )
            {
                var compareAtPrice = data.compareAtPriceText;
            }
            if( data.priceText.length > 0 )
            {
                var fullPrice = data.priceText;
            }
            var months = data.numberOfBottles;
            if( months > 1 )
            {
                var monthText = months + " months"
            }
            else
            {
                var monthText = "month";
            }
            if( isSubscription )
            {
                if( data.subscriptionPriceText.length > 0 )
                {
                    var standardSubscriptionPrice = data.subscriptionPriceText;
                }
                if( data.ssfirstMonthDiscountedPriceText.length > 0 )
                {
                    var firstMonthDiscountedPrice = data.ssfirstMonthDiscountedPriceText;
                }
                if( compareAtPrice )
                {
                    message.innerHTML = 
                    `
                        <span class="hh-widget-price"> ` + standardSubscriptionPrice + ` </span>
                        / ` + monthText
                    ;
                }
                else
                {
                    message.innerHTML = 
                    `
                        <span class="hh-widget-price">` + standardSubscriptionPrice + ` </span>
                        / ` + monthText
                    ;
                }
            }
            else
            {
                if( compareAtPrice )
                {
                    message.innerHTML = 
                    `
                        <span class="hh-widget-price">` + fullPrice + `</span>
                        <span class="hh-widget-compare-price">` + compareAtPrice + `</span>
                    `;
                }
                else
                {
                    message.innerHTML = 
                    `
                        <span class="hh-widget-price">` + fullPrice + `</span>
                    `;
                }
            }
        }
    }
}

function HandlePriceMessageOnInit( )
{
    var wrappers = document.querySelectorAll( ".bundle-product.bundle-product-wrapper" );
    if( wrappers.length > 0 )
    {
        wrappers.forEach( function( wrapper )
        {
            var data = JSON.parse( wrapper.querySelector( ".product_box.active [data-bundle-data]" ).innerHTML );
            HandlePriceMessage( wrapper, data );
        });
    }
}

function ReallyHandleBundleCards( parent, widget, checkedInput )
{
    var bundleProductBoxes = parent.querySelectorAll( ".product_box" );
    bundleProductBoxes.forEach( function( bundleProductBox )
    {
        HandleBundleCardForSubscriptionOption( parent, widget, checkedInput, bundleProductBox );
    } );
}

function HandleBundleCardForSubscriptionOption( parent, widget, checkedInput, bundleProductBox )
{
    var bundleProductData   = bundleProductBox.querySelector( "[data-bundle-data]" );
    bundleProductData       = JSON.parse( bundleProductData.innerHTML );

    var priceData           = GetBundlePrice( checkedInput, bundleProductData ); 
    var target              = bundleProductBox.querySelector( "[data-bundle-price]" );
    var savingContainer     = bundleProductBox.querySelector( ".save_money" );

    target.innerHTML        = priceData.price;

    if( priceData.saving )
    {
        savingContainer.style.opacity = 1;
        savingContainer.innerHTML = `(save ` + priceData.saving + `)`;
    }
    else
    {
        savingContainer.style.opacity = 0;
    }

    if( bundleProductBox.classList.contains( "active" ) )
    {
        var wrapper = bundleProductBox.parentNode;
        HandlePriceMessage( wrapper, bundleProductData, checkedInput );
    }
}

function GetBundlePrice( checkedInput, bundleProductData )
{
    var priceData = {};
    var price = bundleProductData.fullCostIndividualBottleSavingText;

    if( checkedInput.value == "subscribe" )
    {
        if( bundleProductData.ssfirstMonthEachBottlePrice.length > 0 )
        {
            price = bundleProductData.ssfirstMonthEachBottlePrice + `<span>/each</span>`;
        }
        else
        {
            price = bundleProductData.ssCostIndividualBottleSavingText;
        }
        if( bundleProductData.ssSavingDifference.length > 0 )
        {
            var saving = bundleProductData.ssSavingDifference;
            priceData.saving = saving;
        }
    }
    else
    {
        price = bundleProductData.otpIndividualBottlePrice + `<span>/each</span>`;
        if( bundleProductData.otpSavingDifference.length > 0 )
        {
            var saving = bundleProductData.otpSavingDifference;
            priceData.saving = saving;
        }
    }

    priceData.price = price;

    return priceData;
}

window.addEventListener( "DOMContentLoaded", function( )
{
    var bundleProductCards = document.querySelectorAll( ".product_box" );
    if( bundleProductCards && bundleProductCards.length > 0 )
    {
        for( var i = 0; i < bundleProductCards.length; i++ )
        {
            var bundleProductCard = bundleProductCards[ i ];
            bundleProductCard.addEventListener( "click", HandleBundleProductCardClick );
        }
    }
    // var purchaseTypes = document.querySelectorAll( ".hh-subscription-option-input" );
    // if( purchaseTypes.length > 0 )
    // {
    //     for( var i = 0; i < purchaseTypes.length; i++ )
    //     {
    //         var type = purchaseTypes[ i ];
    //         type.addEventListener( "change", function( e )
    //         {
    //             HandlePriceMessageOnInit( );
    //         } );
    //     }
    // }
    HandlePriceMessageOnInit( );
} );

// addEventListener( "DOMContentLoaded", ( event ) =>
// {
//     event.preventDefault();

//     var productForm = document.querySelector("product-form form");
//     if(productForm){
//         if(!productForm.querySelector('input[name="selling_plan"]')){
//             productForm.insertAdjacentHTML("afterbegin",'<input name="selling_plan" type="hidden" value="">');
//         }
//     }
//     setTimeout(function (){
//         $('.rc_widget__option__plans__dropdown').prop('selectedIndex', 0);
//     },500);
//     var product_box = document.querySelectorAll( '.bundle-product .product_box' );
//     product_box.forEach( single_product_box =>
//     {
//         single_product_box.addEventListener( 'click', function ()
//         {
//             // For remove other widgets event
//             window.ReChargeWidget.eventService.listeners["widget:sellingPlans:change"] = [];

//             product_box.forEach( element =>
//             {
//                 element.classList.remove( "active" );
//             });

//             single_product_box.classList.add( "active" );
//             var variant_id = single_product_box.querySelector( 'input[name="variant_id"]' ).value
//             var product_id = single_product_box.querySelector( 'input[name="product_id"]' ).value
//             var productForm = document.querySelector("product-form");

//             productForm.querySelector('input[name="id"]').value = variant_id
//             productForm.querySelector('input[name="product-id"]').value = product_id

//             var price = single_product_box.querySelector( 'input[name="price"]' ).value
//             var compare_at_price = single_product_box.querySelector( 'input[name="compare_price"]' ).value
//             if(document.querySelector(".price__container .price-item--sale")) {
//                 document.querySelector(".price__container .price-item--sale").textContent = price;
//                 document.querySelector(".price__container .compare__price").textContent = compare_at_price;
//             }
             
//             window.ReChargeWidget.createWidget({ productId: product_id, selectors: { price: ['.rc-radio__price'] } });
//             setTimeout(function (){
//                 $('.rc_widget__option__plans__dropdown').prop('selectedIndex', 0);
//                 $('.rc_widget__option__input').change(function (){
//                     setTimeout(function (){
//                         $('.rc_widget__option__plans__dropdown').prop('selectedIndex', 0);
//                     },500);
//                     if($('.rc-radio').hasClass('rc-option--active')){
//                         $('.rc-radio.rc-option--active').find('.rc-radio__input').prop("checked", true);
//                     }
//                     $(this).parent().find('.rc-option__price').val();
//                     let price = $(this).parent().find('.rc-option__price').text().replace(/[\$£€]/g, '');
//                     let active_bundle_product = $('.bundle_product.product_box.active')
//                     let month_supply = active_bundle_product.find('.subscription_price').data('month');
//                     let single_bundle_price = 0;
//                     price = parseFloat(price);
//                     if (month_supply){
//                         month_supply = month_supply.replace('Months', '');
//                         month_supply = parseInt(month_supply);
//                         single_bundle_price = price / month_supply;
//                     }
//                     let price_each = single_bundle_price.toFixed(2);
//                     let store_currency = active_bundle_product.find('.bundle-price').data('currency');
//                     let single_price = active_bundle_product.find('.subscription_price').text(price_each);
//                     $(single_price).prepend(store_currency);
//                 })
//             },500);
//             $('.rc-template .rc-radio:first-child .rc-radio__input').prop("checked", true);
//         });
//     });
// });

// //  Update recharge widget on bundle product change
// window.addEventListener("load", function() {
//     var rechargeWidgetEvent = new Event("ReChargeWidget-loaded");
//     window.dispatchEvent(rechargeWidgetEvent);
// });

// function HandleDefaultPriceMessage( checkedInput )
// {
//     var form = checkedInput.closest( "form" );
//     if( checkedInput.value == "subscribe" )
//     {
//         form.querySelector( "[data-subscription-message]").classList.remove( "hidden" );
//         form.querySelector( "[data-one-time-message]").classList.add( "hidden" );
//     }
//     else
//     {
//         form.querySelector( "[data-subscription-message]").classList.add( "hidden" );
//         form.querySelector( "[data-one-time-message]").classList.remove( "hidden" );
//     }
// }